import { createClient } from '@supabase/supabase-js';
import { handleServiceError } from '../utils/errorHandler';
import config from '../config/environment';

const authClient = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: { persistSession: false },
});

class AuthServiceClass {
  async createUser(email: string, password: string, fullName?: string): Promise<string> {
    const { data, error } = await authClient.auth.signUp({
      email,
      password,
      options: fullName ? { data: { full_name: fullName } } : undefined,
    });

    if (error) {
      if (
        error.message?.toLowerCase().includes('already registered') ||
        error.status === 422
      ) {
        return this.signInExisting(email, password);
      }
      handleServiceError(error, 'criar usuário');
    }

    if (!data.user?.id) {
      throw new Error('Erro ao criar usuário. Verifique as configurações de autenticação.');
    }

    if (data.user.identities?.length === 0) {
      return this.signInExisting(email, password);
    }

    return data.user.id;
  }

  private async signInExisting(email: string, password: string): Promise<string> {
    const { data, error } = await authClient.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      throw new Error('Email já cadastrado. Senha incorreta para o usuário existente.');
    }

    await authClient.auth.signOut();
    return data.user.id;
  }
}

export const AuthService = new AuthServiceClass();
